export const NET_TERMS_OPTIONS = [
  { label: 'None', value: 0, displayText: 'None' },
  { label: 'NET 10', value: 10, displayText: 'NET 10' },
  { label: 'NET 30', value: 30, displayText: 'NET 30' },
  { label: 'NET 60', value: 60, displayText: 'NET 60' },
  { label: 'NET 90', value: 90, displayText: 'NET 90' },
] as const;

export const NET_TERMS_SELECT_OPTIONS = NET_TERMS_OPTIONS.map((option) => ({
  label: option.label,
  value: option.value.toString(),
}));

/**
 * Get display text for payment terms
 * @param netTerms - The NET payment terms number
 * @returns Display text for the payment terms
 */
export const getPaymentTermsDisplayText = (netTerms: number | undefined | null): string => {
  const option = NET_TERMS_OPTIONS.find((opt) => opt.value === netTerms);
  return option ? option.displayText : 'None';
};

/**
 * Get badge variant for NET terms
 * @param netTerms - The NET payment terms number
 * @returns Badge variant
 */
export const getNetTermsBadgeVariant = (netTerms: number) => {
  switch (netTerms) {
    case 10:
    case 30:
      return 'default' as const;
    case 60:
      return 'secondary' as const;
    case 90:
      return 'destructive' as const;
    default:
      return 'outline' as const;
  }
};
